var common = require("../utiles/common")

module.exports = {
    register: function () {
        document.createElement('form-item')
        ko.components.register('form-item', {
            viewModel: function (params) {
                var $this = this;
                var times = 60;
                console.log(params)
                if(params.app){
                    params = params.app;
                }
                $this.errorMessage = ko.observable("");
                $this.id = (params.name + Math.random()).replace("\.", "");
                $this.displayName = params.displayName;
                //$this.rules = params.rules?params.rules:common.createRules(params.form);
                $this.rules = params.rules;
                $this.icon = params.icon;
                $this.type = params.type ? params.type : "input";
                $this.autocomplete = params.noAutocomplete ? "off" : "new-password";
                $this.name = params.name;
                $this.maxlength = params.maxlength;
                $this.placeholder = params.placeholder;
                $this.require = params.form?params.form.required:params.require;
                $this.displayName = params.displayName;
                $this.errorMsg = params.errorMsg;
                $this.disabled = params.disabled;
                $this.notVerify = params.notVerify;
                $this.tel = params.tel;//绑定手机号码

                //select
                $this.options = params.options;
                $this.optionsValue = params.optionsValue?params.optionsValue:'';
                $this.optionsText = params.optionsText?params.optionsText:'';
                $this.selectedOptions = params.selectedOptions;
                $this.selectChange = function(){

                }
                $this.size = params.size;
                //date
                $this.format = params.format;

                $this.noteNone = ko.observable(false);
                $this.codeMsg = ko.observable(commonLocal.app.SendCode);
                $this.value = ko.observable(params.value);
                $this.src = ko.observable();
                if(params.type == "datetime"){
                    $this.value = ko.observable(common.timestampToTime(params.value))
                }
                if(params.type == "date"){
                    $this.value = ko.observable(common.timestampToTime(params.value,"day"))
                }
                if(params.type == "bool"){
                    if(!params.disabled){
                        $this.value($this.value?"true":"false");
                    }else{
                        $this.value = ko.observable(params.value?"是":"否");
                    }
                }
                if(params.type == "select"&&params.disabled){
                    for(var i=0;i<params.options.length;i++){
                        if(params.options[i].value == params.value){
                            $this.value = ko.observable(params.options[i].name);
                        }
                    }
                }
                $this.keypress = function (model, e) {
                    if (params.keypress) {
                        params.keypress(e.keyCode)
                    }
                    return true;
                }
                //日期控件
                if($this.type=='date'){
                    setTimeout(function(){
                        laydate.render({
                            elem: "#"+$this.id
                          });
                    },500)
                }
                //日期时间控件
                if($this.type=='datetime'){
                    setTimeout(function(){
                        laydate.render({
                            elem: "#"+$this.id
                            ,type: 'datetime',
                            format:params.datePattern?"yyyy-MM-dd HH:mm":"yyyy-MM-dd HH:mm:ss"
                          });
                    },500)
                }
                //获取验证
                $this.getVerify = function(){
                    var verifyType = params.verifyType?params.verifyType:"LOGIN";
                    return "/auth/verification/img?type="+verifyType+"&random=" + Math.random()
                }

                // 校验
                $this.validationResult = ko.observable({valid: undefined});
                $this.validate = function () {
                    var result = common.validate($this.value(), $this.rules);
                    $this.validationResult(result);
                    return result;
                }
                $this.value.subscribe($this.validate);

                if ($this.type === "verifyCode") {
                    console.log("进来")
                    $this.src($this.getVerify());
                    $this.reloadVerifyCode = function (e) {
                        console.log($this.verifyType)
                        console.log($this.getVerify())
                        $this.src($this.getVerify());
                    }
                }
                $this.getTime = function(){
                    var time=setInterval(function(){
                        if(times != 0){
                            times--;
                            $this.codeMsg(times+"s")
                        }else{
                            $this.codeMsg(commonLocal.app.SendAgain);
                            $this.noteNone(false);
                            clearInterval(time);
                        }
                    },1000);
                }
                $this.getCode = function(){
                    if($this.noteNone())return false;
                    var phone=$("input[name=phone]").val();
                    var verifyCode=$("input[name=verifyCode]").val();
                    if(!$this.notVerify){
                        if(!verifyCode){
                            common.message("error",commonLocal.describe.PleaseInputTheGraphicVerificationCode);
                            return false;
                        }
                        if(phone){
                            var query={
                                phone:phone,
                                verifyCode:verifyCode,
                            }
                            if(params.codeType){
                                query.type = params.codeType;
                            }
                            if(params.phoneToken){
                                query.token = params.phoneToken
                            }
                            if(/^1\d{10}$/.test(phone)&&!$this.noteNone()){
                                common.fetch("/auth/credential/sendSMS", {
                                    type: "POST", query: query,
                                    handleError: function (data) {
                                        $("img.verifyImg").attr("src", $this.getVerify());
                                    },
                                    success: function (result) {
                                        $this.errorMessage("");
                                        $this.noteNone(true);
                                        $this.getTime();
                                    }
                                })
                            }else{
                                common.message("error",commonLocal.describe.IncorrectFormatOfMobilePhoneNumber);
                            }
                        }else{
                            var query={verifyCode:verifyCode,url:params.url,baseUrl:params.baseUrl};
                            if(!$this.noteNone()){
                                common.fetch("/auth/credential/sendSMSNoPhone", {
                                    type: "GET", query: query,
                                    handleError: function (data) {
                                        $("img.verifyImg").attr("src", $this.getVerify());
                                    },
                                    success: function (result) {
                                        $this.errorMessage("");
                                        $this.noteNone(true);
                                        $this.getTime();
                                    }
                                })
                            }else{
                                common.message("error",commonLocal.describe.IncorrectFormatOfMobilePhoneNumber);
                            }
                        }

                    }else{
                        if(/^1\d{10}$/.test(phone)&&!$this.noteNone()){
                            common.fetch("/auth/sendSMS", {
                                type: "GET", query: {phone:phone,url:params.url,baseUrl:params.baseUrl},
                                handleError: function (data) {
                                    $("img.verifyImg").attr("src", $this.getVerify());
                                },
                                success: function (result) {
                                    $this.errorMessage("");
                                    $this.noteNone(true);
                                    $this.getTime();
                                }
                            })
                        }else{
                            common.message("error",commonLocal.describe.IncorrectFormatOfMobilePhoneNumber);
                        }
                    }
                }
                if($this.type=="noteCode"){

                }
                // 加载完成后Fix Placeholder
                setTimeout(function () {
                    common.fixPlaceholder($this)
                }, 1);
                // 将自己加到父组件的form对象中
                if (params.form) {
                    if (params.form.formItems === undefined) {
                        params.form.formItems = []
                    }
                    params.form.formItems.push($this)
                }
            },
            template: require("./FormItem.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/template/FormItem.js
// module id = 68
// module chunks = 0